import { useSelectSpotModal } from '../screens/order/select-spot-modal';
import { useSpotRejectedModal } from '../screens/order/spot-rejected-modal';

function useSpotWorkflow() {
  const { prepareSelectSpotModal, showSelectSpotModal } = useSelectSpotModal();
  const { showSpotRejectedModal } = useSpotRejectedModal();

  async function prepare() {
    await prepareSelectSpotModal();
  }

  async function show({ prepareOnPreConfirm } = {}) {
    const result = await showSelectSpotModal({
      prepareOnPreConfirm,
    });

    if (result.isDismissed) {
      await showSpotRejectedModal();
    }

    return result;
  }

  return {
    prepareSpotWorkflow: prepare,
    showSpotWorkflow: show,
  };
}

export { useSpotWorkflow };
